'use client';
const containerStyles = {
    width: '100%'
};

export { containerStyles };
//# sourceMappingURL=TabNavigationWidget.styles.js.map
